import { HOME_API, webgate } from '../../shared/lib/api';
import HOME_QUERY from './ArtistHomeQuery';

async function query(artistId: string) {
  const options = {
    body: JSON.stringify({
      query: HOME_QUERY,
      variables: {},
    }),
  };
  return webgate.post(
    `${HOME_API}/v1/artist/${artistId}/home`,
    options,
  ) as Promise<HomeResponse>;
}

/* eslint-disable-next-line import/no-default-export */
export default query;

enum CardType {
  TITLE_ONLY = 'TITLE_ONLY',
  REMOTE = 'REMOTE',
  DISPLAY = 'DISPLAY',
}

enum HeaderType {
  UNKNOWN_HEADER_TYPE = 'UNKNOWN_HEADER_TYPE',
  IMAGE_URL = 'IMAGE_URL',
  TEXT = 'TEXT',
  DELTA = 'DELTA',
}

enum DisplayType {
  UNKNOWN_DISPLAY_TYPE = 'UNKNOWN_DISPLAY_TYPE',
  COVER = 'COVER',
  ICON = 'ICON',
  STAT = 'STAT',
  INFO = 'INFO',
}

type HomeResponse = {
  data: HomeData;
};

type HomeData = {
  homestats: HomeStats;
};

type HomeStats = {
  artistinsights?: ArtistInsightsData;
  cards?: HomeCards;
};

type HomeCards = {
  cardsList: Card[];
};

type Card = {
  uuid: string;
  resourceUri: string;
  cardType: CardType;
  cardSource: string;
  notificationClass: string;
  displayCard?: DisplayCard;
  clickExpirationBuffer?: Duration;
};

type DisplayCard = {
  header: string;
  title: string;
  subtitle: string;
  fallbackImageUrl?: string;
  displayType: DisplayType;
  headerType: HeaderType;
  callToAction?: CallToAction;
  cardColorList: CardColor[];
};

type Duration = {
  day?: number;
  hour?: number;
  minute?: number;
  second?: number;
};

type CardColor = {
  preset: string;
  colorHex: string;
};

type CallToAction = {
  text: string;
  url: string;
};

type ArtistInsightsData = {
  overview: ArtistOverview;
  playlistStatsTable: PlaylistStatsTable;
  recordingStatsTable: RecordingStatsTable;
  latestDate?: string;
};

type ArtistOverview = {
  followers?: Overview;
  listeners?: Overview;
  streams?: Overview;
};

type Overview = {
  delta?: number;
  total?: number;
  deltaPct?: number;
};

type PlaylistStatsTable = {
  playlistStatsList: PlaylistStats[];
};

type PlaylistStats = {
  uri?: string;
  listeners?: number;
  followers?: number;
  streams?: number;
  title?: string;
  thumbnailUrl?: string;
  isPersonalized?: boolean;
};

type RecordingStatsTable = {
  recordingStatsList: RecordingStats[];
};

type RecordingStats = {
  numListeners?: number;
  numStreams?: number;
  isDisabled?: boolean;
  trackName?: string;
  trend?: number;
  trackUri?: string;
  pictureUri?: string;
};
